import React, {ReactElement} from 'react';
import {toReadable} from 'shared/utils/number';
import {formatDateTime} from 'shared/utils/dateTime';
import {DynamicFontSize} from 'components/DynamicFontSize';
import {Shout, Text} from 'components/Text';
import {Section} from 'components/Section';
import {Wrapper} from './style';
import {isSpend} from 'core/Record';

interface RecordProps {
  record: RecordEntry;
}

export const Record = ({record}: RecordProps): ReactElement => {
  const {amount, dateTime, type} = record;
  const prefix = isSpend(record) ? '' : '+';

  return (
    <Wrapper>
      <Section className={type.toLowerCase()}>
        <Shout>
          <DynamicFontSize>
            {prefix}
            {toReadable(amount)}
          </DynamicFontSize>
        </Shout>
        <Text>{formatDateTime(dateTime)}</Text>
      </Section>
    </Wrapper>
  );
};
